import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageAdminUser
{
    constructor(targetElement)
    {
        const userId = targetElement.dataset.userid;
        let url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o");

        this.projects = web.projects;
        this.projects.getUserProjects(userId, true, limit, offset);
        const rolesTab = ele.byId("roles");
        const autoSuggests = rolesTab.querySelectorAll("[data-autosuggest]");
        web.initializeAutosuggestsFromApi(autoSuggests);
    }

    removeRole(button)
    {
        web.buttons.startSavingAnimButton(button);

        const key = button.dataset.key;
        const userId = button.dataset.userId;

        api.delete(
            "user_roles/user/" + userId + "/" + key,
            {},
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false);
                const errorEle = ele.byId("role-error");
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- removing role not possible: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    addRole(button)
    {
        web.buttons.startSavingAnimButton(button);

        const suggestField = ele.byId("user-add-role");
        const key = suggestField.dataset.autosuggestValue || suggestField.value;
        const userId = suggestField.dataset.userId;

        api.post(
            "user_roles/user/" + userId + "/" + key,
            {},
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false);
                const errorEle = ele.byId("role-error");
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- adding role not possible: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    getOpsTable(targetElement)
    {
        api.get("admin/user/" + targetElement.dataset.userId + "/ops", (res) =>
        {
            if (res && res.data)
            {
                const patchesTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.patches });
                const usersTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.users });
                const teamsTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.teams });
                const extensionsTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.extensions });
                const baseTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.base });
                web.setHandleBarHtml("settings_mydata_ops", { "ops": res.data, patchesTable, usersTable, teamsTable, extensionsTable, baseTable, "hideDownload": true }, targetElement);
                web.tabs.initTabs(targetElement.querySelectorAll("ul.tab-bar li"));
            }
        });
    }
}
